import { generatePath } from 'react-router-dom';

import { MONEY_PRO } from '#client/constants/navItemsIds';
import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the money menu items.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 * }} params
 * @returns {Array}
 */
function getMoneyMenuItems({ businessEntityUuid, entitlements }) {
  const hasMoneyPro = entitlements.has('money_pro');

  return [
    {
      order: 10,
      title: 'Overview',
      itemId: 'money_overview',
      path: generatePath(ROUTES.entityMoney, { businessEntityUuid })
    },
    {
      order: 20,
      show: hasMoneyPro,
      title: 'Money Out',
      itemId: 'money_expenses',
      path: generatePath(ROUTES.entityMoney, { businessEntityUuid, '*': 'expenses' })
    },
    {
      order: 30,
      show: hasMoneyPro,
      title: 'Invoices',
      itemId: 'money_invoices',
      path: generatePath(ROUTES.entityMoney, { businessEntityUuid, '*': 'invoices' })
    },
    {
      order: 40,
      show: hasMoneyPro,
      title: 'Time & Task',
      itemId: 'money_time_task',
      path: generatePath(ROUTES.entityMoney, { businessEntityUuid, '*': 'time-dash' })
    },
    {
      order: 50,
      show: hasMoneyPro,
      title: 'Money In',
      itemId: 'money_income',
      path: generatePath(ROUTES.entityMoney, { businessEntityUuid, '*': 'income' })
    },
    {
      order: 60,
      show: hasMoneyPro,
      title: 'Mileage Tracking',
      itemId: 'money_mileage_tracking',
      path: generatePath(ROUTES.entityMoney, { businessEntityUuid, '*': 'mileage' })
    },
    {
      order: 70,
      show: hasMoneyPro,
      title: 'Taxes',
      itemId: 'money_taxes',
      path: generatePath(ROUTES.entityMoney, { businessEntityUuid, '*': 'taxes' })
    },
    {
      order: 80,
      show: hasMoneyPro,
      title: 'Reports',
      itemId: 'money_reports',
      path: generatePath(ROUTES.entityMoney, { businessEntityUuid, '*': 'reports' })
    }
  ];
}

/**
 * Get the money studio menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getMoneyMenu({ businessEntityUuid, entitlements, order }) {
  return processMenu({
    title: 'Money Pro',
    itemId: MONEY_PRO,
    icon: 'money-fill.svg',
    links: getMoneyMenuItems({ businessEntityUuid, entitlements }),
    order
  });
}
